import React from "react";

// Marca de agua publicitaria al pie de cada portal. NO se incluye en PDFs ni imágenes.
const SOCIALS = {
  instagram: "https://www.instagram.com/uaicardmx",
  facebook: "https://www.facebook.com/uaicardmx",
  tiktok: "https://www.tiktok.com/@uaicardmx",
};

const IconInstagram = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);
const IconFacebook = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);
const IconTikTok = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.4c-1.2.1-2.4-.2-3.5-.8v5.9c0 3.1-2.5 5.6-5.6 5.6S5.3 17.5 5.3 14.4c0-3 2.3-5.4 5.3-5.6v2.5c-.2 0-.4-.1-.6-.1-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9V3z" />
  </svg>
);

export default function SiteFooter({ variant = "light" }) {
  const isDark = variant === "dark";
  const base = isDark ? "text-white/70" : "text-nardo-500";
  const hover = isDark ? "hover:text-white" : "hover:text-navy";
  const border = isDark ? "border-white/15" : "border-nardo-200";
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const privacyHref = path.startsWith("/padres") ? "/privacidad-padres"
    : path.startsWith("/docente") ? "/privacidad-docentes"
    : path.startsWith("/alumno") ? "/privacidad-alumno"
    : "/privacidad-general";
  const items = [
    { key: "instagram", label: "Instagram", url: SOCIALS.instagram, Icon: IconInstagram },
    { key: "facebook", label: "Facebook", url: SOCIALS.facebook, Icon: IconFacebook },
    { key: "tiktok", label: "TikTok", url: SOCIALS.tiktok, Icon: IconTikTok },
  ];
  return (
    <footer data-testid="site-footer" className={`mt-10 border-t ${border} pt-6 pb-8 select-none`}>
      <div className={`flex flex-col items-center gap-3 opacity-70 ${base}`}>
        <div className="text-center">
          <span className="text-[10px] uppercase tracking-[0.35em]">Contáctanos</span>
          <div className={`font-display font-bold tracking-tight ${isDark ? "text-white" : "text-navy"} text-lg leading-tight`}>ZAVIA</div>
        </div>
        <div className="flex items-center gap-4">
          {items.map(({ key, label, url, Icon }) => (
            <a
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              data-testid={`footer-${key}`}
              className={`transition-colors ${base} ${hover}`}
            >
              <Icon width={20} height={20} />
            </a>
          ))}
        </div>
        <a href={privacyHref} data-testid="footer-privacy" className={`text-[11px] underline underline-offset-2 transition-colors ${base} ${hover}`}>
          Aviso de Privacidad
        </a>
      </div>
    </footer>
  );
}
